import { cast, Instance, types } from 'mobx-state-tree';

import ToolsConfigItem from '@store/accountsPayableLink/models/ToolsConfigItem';

const AccountsPayableTools = types
  .model({
    // Use for internal state changes
    toolsSelectedColumns: types.optional(types.array(ToolsConfigItem), []),
    toolsGroupBy: types.optional(types.string, ''),
    // Config returned from backend
    toolsConfigGroupBy: types.optional(types.array(ToolsConfigItem), []),
    toolsConfigShowColumns: types.optional(types.array(ToolsConfigItem), []),
  })
  .views((self) => ({
    get getToolsSelectedColumnsLength() {
      return self.toolsSelectedColumns.length;
    },
  }))
  .actions((self) => ({
    setToolsSelectedColumns: (columns: any) => {
      self.toolsSelectedColumns = columns;
    },
    setToolsGroupBy: (groupBy: any) => {
      self.toolsGroupBy = groupBy;
    },
    updateConfigTools: (tools: any) => {
      self.toolsConfigGroupBy = cast(tools.groupBy);
      self.toolsConfigShowColumns = cast(tools.showColumns);
    },
  }));

export interface IAccountsPayableTools extends Instance<typeof AccountsPayableTools> {}
export default AccountsPayableTools;
